export default __webpack_public_path__ + "static/media/burjeel-logo.eff89e55.svg";